import { useState } from "react";
import { Link } from "react-router-dom";
import { useMagnetic, useScrollScrub } from "../../lib/motion";

export default function Closing() {
  const bg = useScrollScrub();
  const cta = useMagnetic();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSent(true);
    setEmail("");
  };

  return (
    <section className="closing" ref={bg}>
      <div className="closing__bg">
        <img src={`${process.env.PUBLIC_URL || ""}/images/look-01.jpg`} alt="" loading="lazy" />
        <span className="closing__wash" aria-hidden="true" />
      </div>

      <div className="wrap wrap--narrow closing__inner">
        <span className="eyebrow eyebrow--light">READY WHEN YOU ARE</span>

        <h2 className="closing__title">
          وقتشه نوبت خودت
          <br />
          رو رزرو کنی
        </h2>

        <p className="closing__lede">
          یک تماس لازم نیست — همین‌جا روز و ساعتت را انتخاب کن.
        </p>

        <Link ref={cta} to="/booking" className="btn btn--light magnetic closing__btn">
          رزرو نوبت
        </Link>

        <div className="closing__news">
          {sent ? (
            <p className="closing__done" role="status">ثبت شد — ممنون که همراه ما هستی.</p>
          ) : (
            <form onSubmit={submit}>
              <label htmlFor="closing-email" className="sr-only">نشانی ایمیل</label>
              <input
                id="closing-email"
                type="email"
                required
                placeholder="ایمیل، برای خبر تخفیف‌ها"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit">عضویت</button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
